// index.js or main file
import React, { useState,useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import Stage1 from './pages/stage1/stage1';
import Stage2 from './pages/stage2/stage2';
import Stage3 from './pages/stage3/stage3';
import Stage4 from './pages/stage4/stage4';
import Stage5 from './pages/stage5/stage5';
import Stage6 from './pages/stage6/stage6';
import Intro from './pages/intro/intro';
import Rules from './pages/rules/rules';

import Thankyou from './pages/thankyou/thankyou';
import DDDUI from './pages/dddUI/ddd';
import Modal from "react-modal";


Modal.setAppElement("#root"); 

function usePageBackground() {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;

    body.classList.remove('common-bg');

    // switch (location.pathname) {
    //   case '/':
    //   case '/login':
    //     body.classList.add('common-bg');
    //     break;
    //   case '/stage1':
    //     body.classList.add('common-bg');
    //     break;
    //    case '/stage3':
    //     body.classList.add('common-bg');
    //     break;
    //   case '/intro':
    //     body.classList.add('common-bg');
    //     break;
    //   case '/thankyou':
    //     body.classList.add('common-bg');
    //     break;
   
    //     default:
    //     break;
    // }
  }, [location]); 
}


function App() {
  usePageBackground();
  const navigate = useNavigate();
   
     // Get initial image from sessionStorage or env variable
     const getInitialImage = () => {
       return sessionStorage.getItem("orgData") || process.env.REACT_APP_EM_LOGO;
     };
   
     // State for header config
     const [headerConfig, setHeaderConfig] = useState({
       imageUrl: getInitialImage(),
       backButtonRedirect: "/", // Default back button
     });
   
     // Update both image and back button together (ONLY from Login)
     const updateHeader = ({ imageUrl, backButtonRedirect }) => {
       setHeaderConfig((prev) => ({
         imageUrl: imageUrl || prev.imageUrl, // Only update if provided
         backButtonRedirect: backButtonRedirect || prev.backButtonRedirect, // Only update if provided
       }));
   
       // Store image in sessionStorage if provided
       if (imageUrl) sessionStorage.setItem("orgData", imageUrl);
     };
   
   
     const handleBack = () => {
       const { backButtonRedirect } = headerConfig;
   
       if (backButtonRedirect.length > 20) {
         // Open in new tab (External Link)
         window.location.href = backButtonRedirect;
       } else {
         // Internal Navigation
         navigate(backButtonRedirect);
       }
     };
   
  

  return (
<DDDUI imageUrl={headerConfig.imageUrl} onBack={handleBack}>
      <Routes>
        <Route path="/" element={<Login updateHeader={updateHeader}/>} />
        <Route path="/stage1" element={<Stage1 updateHeader={updateHeader}/>} />
        <Route path="/stage2" element={<Stage2 updateHeader={updateHeader}/>} />
        <Route path="/stage3" element={<Stage3 updateHeader={updateHeader}/>} />
        <Route path="/stage4" element={<Stage4 updateHeader={updateHeader}/>} />
        <Route path="/stage5" element={<Stage5 updateHeader={updateHeader}/>} />
        <Route path="/stage6" element={<Stage6 updateHeader={updateHeader}/>} />
        <Route path="/login" element={<Login updateHeader={updateHeader} />} />
        <Route path="/intro" element={<Intro updateHeader={updateHeader}/>} />
        <Route path="/rules" element={<Rules updateHeader={updateHeader}/>} />

        <Route path="/thankyou" element={<Thankyou updateHeader={updateHeader}/>} />
        
      </Routes>
      </DDDUI>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();




